<template>
    <div>
        <c-form-group class="form-group required-field">
            <label for="email">Email</label>
            <input type="email" class="form-control disabled" id="email" v-model="email" name="email" readonly />
            <div v-if="$v.email.$error && !$v.email.required" class="required">* Email obrigatório</div>
            <div v-else-if="$v.email.$error && !$v.email.email" class="required">* Email inválido</div>
        </c-form-group>
    
        <c-heading-3 class="form-title">Tipo de conta</c-heading-3>

        <div class="d-flex">

            <c-form-group class="form-group" style="margin-right: 1.4rem;">
                <input 
                    type="radio" 
                    value="F" 
                    v-model="user_type"
                    id="pf" 
                    class="tipo_pessoa" 
                    name="user_type" 
                    @change="typePerson(user_type)"  
                />
                <label for="pf">Pessoa Física</label>
            </c-form-group>

            <c-form-group class="form-group">
                <input 
                    type="radio" 
                    value="J" 
                    v-model="user_type" 
                    id="pj" 
                    class="tipo_pessoa"  
                    name="user_type" 
                    @change="typePerson(user_type)"  
                />
                <label for="pj">Pessoa Jurídica</label>
            </c-form-group>
            <div v-if="$v.user_type.$error && !$v.user_type.required" class="required">* Selecione o tipo de conta</div>
        </div>

        <c-heading-3 v-if="user_type === 'J'" class="form-title" >Dados da empresa</c-heading-3>

        <c-form-group class="form-group required-field">
            <label for="cpfcnpj" id="type_person">{{ setTypeRegister(user_type) }}</label>
            <input type="text" class="form-input form-wide mb-2" id="cpfcnpj" name="user_cpfcnpj" v-mask="maskRegister" v-model="user_cpfcnpj" />
            <div v-if="$v.user_cpfcnpj.$error && !$v.user_cpfcnpj.required" class="required">* {{ setTypeRegister(user_type) }} obrigatório</div>
        </c-form-group>

        <div v-if="user_type === 'J'">

            <c-form-group class="form-group required-field">
                <label for="fantasy_name">Nome fantasia</label>
                <input 
                    type="text" 
                    class="form-input form-wide mb-2" 
                    id="fantasy_name"  
                    name="user_fantasy_name"
                    v-model="user_fantasy_name"
                />
                <div v-if="$v.user_fantasy_name.$error && !$v.user_fantasy_name.required" class="required">* Nome fantasia obrigatório</div>
            </c-form-group>

            <c-form-group class="form-group required-field">
                <label for="user_company_name">Razão social</label>
                <input 
                    type="text" 
                    class="form-input form-wide mb-2" 
                    id="user_company_name" 
                    v-model="user_company_name" 
                    name="user_company_name" 
                />
                <div v-if="$v.user_company_name.$error && !$v.user_company_name.required && user_type === 'J'"  class="required">* Razão social obrigatório</div>
            </c-form-group>

            <div class="row">
                
                <div class="col-md-8">
                    <c-form-group class="form-group">
                        <label for="user_ie">Inscrição estadual</label>
                        <input 
                            type="text" 
                            class="form-input form-wide mb-2" 
                            id="user_ie" 
                            name="user_ie" 
                            v-model="user_ie"
                            :readonly="user_isento" 
                            :disabled="user_isento"
                        />
                        <div v-if="$v.user_ie.$error && !$v.user_ie.required" class="required">* Inscrição estadual obrigatório</div>
                    </c-form-group>
                </div>

                <div class="col-md-4">
                    <c-form-group class="form-group">
                        <label>Isento</label>
                        <input type="checkbox" class="form-input form-wide mb-2" style="display:none;" id="user_isento" v-model="user_isento"  name="user_isento">
                        <ul class="config-swatch-list">
                            <li @click="checkIsento(user_isento);" id="li_isento" :class="[user_isento ? 'inputIsentoChecked': '', 'active input_checkbox']" >
                                <a></a>
                            </li>
                        </ul>
                    </c-form-group>
                </div>

            </div>
        </div>

        <c-heading-3 v-if="user_type === 'F'" class="form-title">Dados pessoais</c-heading-3>

        <c-form-group v-if="user_type === 'F'" class="form-group required-field">
            <label for="name">Nome</label>
            <input 
                type="text" 
                class="form-input form-wide mb-2" 
                id="name" 
                v-model="name" 
                name="name" 
            />
            <div v-if="$v.name.$error && !$v.name.required && user_type === 'F'" class="required">* Nome obrigatório</div>
        </c-form-group>

        <c-form-group v-if="user_type === 'F'" class="form-group required-field">
            <label for="lastname">Sobrenome</label>
            <input 
                type="text" 
                class="form-input form-wide mb-2" 
                id="lastname" 
                v-model="lastname" 
                name="lastname" 
            />
            <div v-if="$v.lastname.$error && !$v.lastname.required && user_type === 'F'" class="required">* Sobrenome obrigatório</div>
        </c-form-group>

        <c-form-group v-if="user_type === 'F'" class="form-group required-field">
            <label for="user_birthday">Data de nascimento</label>
            <input 
                type="text" 
                class="form-input form-wide mb-2 data_nasc"
                id="user_birthday" 
                v-model="user_birthday" 
                name="user_birthday" 
                v-mask="'##/##/####'"
            />
            <div v-if="$v.user_birthday.$error && !$v.user_birthday.required" class="required">* Data de nascimento obrigatório</div>
        </c-form-group>

        <c-form-group class="form-group required-field">
            <label for="password">Senha (mínimo 6 caracteres)</label>
            <input 
                type="password" 
                class="form-input form-wide mb-2" 
                id="password" 
                minlength="6" 
                v-model="password" 
                name="password" 
            />
            <div v-if="$v.password.$error && !$v.password.required" class="required">* Senha obrigatório</div>
            <div v-else-if="$v.password.$error && !$v.password.minLength" class="required"> Minímo de caracteres 6 </div>
        </c-form-group>

        <c-form-group class="form-group required-field">
            <label for="password_c">Confirmar senha</label>
            <input 
                type="password" 
                class="form-input form-wide mb-2" 
                id="password_c" 
                minlength="6" 
                v-model="password_confirmation" 
                name="password_confirmation" 
                
            />
            <div v-if="$v.password_confirmation.$error && !$v.password_confirmation.required" class="required">* Senha obrigatório</div>
            <div v-else-if="$v.password_confirmation.$error && !$v.password_confirmation.sameAsPassword" class="required">As senhas precisam ser idênticas</div>
        </c-form-group>
    </div>
</template>

<script>
import { required, minLength, requiredIf, sameAs, email } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import { CFormGroup, CHeading3 } from '../../Styles/Components/styled'
 
export default {
    name:'DadosPessoais',
    components: {
        'c-form-group': CFormGroup,
        'c-heading-3': CHeading3
    },
    data() {
        return {
            maskRegister: "###.###.###-##",
            email: null,
            user_type:'F',
            user_cpfcnpj: null,
            name: null,
            user_birthday: null,
            user_fantasy_name: null,
            user_company_name: null,
            user_ie: null,
            user_isento: true,
            password: null,
            password_confirmation: null,
            name: null,
            lastname: null
        }
    },
    validations: {
        email: {required, email},
        user_type: {required},
        user_cpfcnpj:{required},
        user_birthday:{required: requiredIf(function(val) {
            return this.user_type === 'F'
        })},
        user_fantasy_name: {required: requiredIf(function(val) {
            return this.user_type === 'J'
        })},
        name: {
            required: requiredIf(function(val) {
                return this.user_type === 'F'
            })
        },
        lastname: {
            required: requiredIf(function(val) {
                return this.user_type === 'F'
            })
        },
        user_company_name: { 
            required: requiredIf(function(val) {
                return this.user_type === 'J'
            })
        },
        user_ie: {
            required: requiredIf(function(val) {
                return this.user_type === 'J' && this.user_isento === false
            })
        },
        user_isento: {
            required: requiredIf(function(val) {
                return this.user_type === 'J' && val === true
            })
        },
        password: {
            required,
            minLength: minLength(6)
        },
        password_confirmation: {
            required,
            sameAsPassword: sameAs('password')
        }
    },
    methods: {

        setTypeRegister(type) {
            if(type === 'F') {
                return 'CPF'
            }
            return 'CNPJ'
        },
        typePerson(type) {
            this.user_cpfcnpj = null
            if(type === 'F') {
                this.maskRegister = "###.###.###-##"
                return
            }
            this.user_birthday = null
            this.user_fantasy_name = null
            this.user_company_name = null
            this.maskRegister = "##.###.###/####-##"
        },
        checkIsento(isento) {
            if(isento === false) {
                this.user_isento = true
                this.user_ie = null
                return
            }
            this.user_isento = false
            this.user_ie = null
        },
        validate() {
            this.$v.$touch();
            var isValid = !this.$v.$invalid
            this.$emit('on-validate', this.$data, isValid)
            return isValid
        }
    },
    watch: {
        email_register(email) {
            this.email = email
        }
    },
    computed: {
        ...mapState("clients", [
            "email_register"
        ])
    }
}
</script>
<style scoped>
.inputIsentoChecked {
    background-color: #EDE56A;
}
</style>